<app-breadcrumb [title]="'Application Details'"></app-breadcrumb>
<div class="container-fluid my-5">
    <div class="row">
        <div class="col">
            <app-loader [show]="skeleton"></app-loader>
            <div *ngIf="setting?.financialYearId == financialYearId">
                <div class="d-flex justify-content-between mb-3">
                    <!-- Left-aligned Back to View button -->
                    <a class="btn btn-primary mr-2" (click)="goBack()">
                        BACK TO VIEW
                    </a>

                    <!-- Right-aligned buttons -->
                    <div>
                        <a class="btn btn-primary mr-2"
                            [routerLink]="['/region/employees/service-book/present-place', profile.userId,financialYearId]">Edit
                            Present Place</a>
                        <a class="btn btn-primary mr-2"
                            [routerLink]="['/region/employees/service-book', profile.userId,financialYearId]">Edit
                            Service
                            Book</a>
                        <a class="btn btn-primary mr-2"
                            [routerLink]="['/region/employees/edit-contact', profile.userId,financialYearId]">Edit
                            Contact
                            Details</a>
                        <a class="btn btn-primary"
                            [routerLink]="['/region/employees/edit', profile.userId,financialYearId]">Edit
                            Profile</a>
                    </div>
                </div>
                <div *ngIf="profile">
                    <app-employee-profile [profile]="profile" [transferRequest]="transferRequest" [isEdit]="false">
                    </app-employee-profile>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profile">
                        <span class="fw-bold mr-2">Claimed Category:</span>
                        <span [innerHtml]="getCategories(profile)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligibleCategory(profileStatus, profile)"></span>
                    </div>
                    <!-- <p *ngIf="profileStatus">Principal Remark: {{ profileStatus.principalRemark }}</p> -->
                    <p *ngIf="profileStatus">Approval-I (Biodata) Principal Remark: {{ profileStatus.principalRemark }}</p>
                    <p *ngIf="transferRequest">Approval-II (Transfer Request) Principal Remark: {{ transferRequest.principalRemark }}</p>
                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligibleCategory(profileStatus, profile)"></span>
                    </div>
                    <!-- <p *ngIf="profileStatus">RO Remark: {{ profileStatus.roRemark }}</p> -->
                    <p *ngIf="profileStatus">Approval-I (Biodata) RO Remark: {{ profileStatus.roRemark }}</p>
                    <p *ngIf="transferRequest">Approval-II (Transfer Request) RO Remark: {{ transferRequest.roRemark }}</p>
                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatus==null && transferRequest.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligiblePlaneCategory(profile)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatus==null && transferRequest.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligiblePlaneCategory(profile)"></span>
                    </div>

                </div>
            </div>
            <div *ngIf="setting?.financialYearId != financialYearId">
                <ng-container *ngIf="profileLog; else noData">
                <div *ngIf="profileLog">
                    <div class="d-flex justify-content-between mb-3">
                        <!-- Left-aligned Back to View button -->
                        <a class="btn btn-primary mr-2" (click)="goBack()">
                            BACK TO VIEW
                        </a>

                        <!-- Right-aligned buttons -->
                        <div>
                            <a class="btn btn-primary mr-2"
                                [routerLink]="['/region/employees/service-book/present-place', profileLog.userId,financialYearId]">Edit
                                Present Place</a>
                            <a class="btn btn-primary mr-2"
                                [routerLink]="['/region/employees/service-book', profileLog.userId,financialYearId]">Edit
                                Service
                                Book</a>
                            <a class="btn btn-primary mr-2"
                                [routerLink]="['/region/employees/edit-contact', profileLog.userId,financialYearId]">Edit
                                Contact
                                Details</a>
                            <a class="btn btn-primary"
                                [routerLink]="['/region/employees/edit', profileLog.userId,financialYearId]">Edit
                                Profile</a>
                        </div>
                    </div>
                    <app-employee-profile [profileLog]="profileLog" [transferRequestLog]="transferRequestLog" [isEdit]="false">
                    </app-employee-profile>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileLog">
                        <span class="fw-bold mr-2">Claimed Category:</span>
                        <span [innerHtml]="getCategoriesLog(profileLog)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatusLog">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligibleCategoryLog(profileStatusLog, profileLog)"></span>
                    </div>
                    <!-- <p *ngIf="profileStatusLog">Principal Remark: {{ profileStatusLog?.principalRemark }}</p> -->
                    <p *ngIf="profileStatusLog">Approval-I (Biodata) Principal Remark: {{ profileStatusLog.principalRemark }}</p>
                    <p *ngIf="transferRequestLog?.length > 0">
                        Approval-II (Transfer Request) Principal Remark: {{ transferRequestLog[0]?.principalRemark }}
                      </p>
                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatusLog">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligibleCategoryLog(profileStatusLog, profileLog)"></span>
                    </div>
                    <!-- <p *ngIf="profileStatusLog">RO Remark: {{ profileStatusLog?.roRemark }}</p> -->
                    <p *ngIf="profileStatusLog">Approval-I (Biodata) RO Remark: {{ profileStatusLog.roRemark }}</p>
                    <p *ngIf="transferRequestLog?.length > 0">
                        Approval-II (Transfer Request) RO Remark: {{ transferRequestLog[0]?.roRemark }}
                      </p>
                    <!-- <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatusLog==null && transferRequestLog?.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligiblePlaneCategoryLog(profileLog)"></span>
                    </div> -->

                    <!-- <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatusLog==null && transferRequestLog?.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligiblePlaneCategoryLog(profileLog)"></span>
                    </div> -->

                </div>
                </ng-container>
                <ng-template #noData>
                    <div *ngIf="profile">
                        <app-employee-profile [profile]="profile" [transferRequest]="transferRequest" [isEdit]="false">
                        </app-employee-profile>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="transferRequest">
                            <span class="fw-bold mr-2">Claimed Category:</span>
                            <span [innerHtml]="getCategories(profile)"></span>
                        </div>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                            <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                            <span [innerHtml]="getPrincipalEligibleCategory(profileStatus, profile)"></span>
                        </div>
                        <!-- <p *ngIf="profileStatus">Principal Remark: {{ profileStatus.principalRemark }}</p> -->
                        <p *ngIf="profileStatus">Approval-I (Biodata) Principal Remark: {{ profileStatus.principalRemark }}</p>
                        <p *ngIf="transferRequest">Approval-II (Transfer Request) Principal Remark: {{ transferRequest.principalRemark }}</p>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                            <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                            <span [innerHtml]="getROEligibleCategory(profileStatus, profile)"></span>
                        </div>
                        <!-- <p *ngIf="profileStatus">RO Remark: {{ profileStatus.roRemark }}</p> -->
                        <p *ngIf="profileStatus">Approval-I (Biodata) RO Remark: {{ profileStatus.roRemark }}</p>
                        <p *ngIf="transferRequest">Approval-II (Transfer Request) RO Remark: {{ transferRequest.roRemark }}</p>
                        <div class="mb-3 d-flex justify-content-start"
                            *ngIf="profileStatus==null && transferRequest.isTransfer">
                            <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                            <span [innerHtml]="getPrincipalEligiblePlaneCategory(profile)"></span>
                        </div>
    
                        <div class="mb-3 d-flex justify-content-start"
                            *ngIf="profileStatus==null && transferRequest.isTransfer">
                            <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                            <span [innerHtml]="getROEligiblePlaneCategory(profile)"></span>
                        </div>
    
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>